export default {
  hero: {
    eyebrow: 'Verified game keys',
    title: 'Game keys,\ndelivered the\nmoment you pay.',
    subtitle:
      'Experience premium digital purchasing. Secure European checkout, transparent pricing, and instant delivery to your inbox. No hidden fees, no wait times.',
    browseCatalog: 'Browse catalog',
    howItWorks: 'How it works',
    trustInstantDelivery: 'Instant delivery',
    trustVerifiedKeys: 'Verified keys',
    trustSecureCheckout: 'Secure EUR checkout',
    loadingCovers: 'Loading…',
  },
  featured: {
    heading: 'Featured this week',
    viewAll: 'View all in catalog',
    loading: 'Loading featured games…',
    empty: 'No products yet.',
    addToFavorites: 'Add to favorites',
    removeFromFavorites: 'Remove from favorites',
    startingFrom: 'Starting from {price}',
  },
  howItWorks: {
    heading: 'How GladKey works',
    prevStep: 'Previous step',
    nextStep: 'Next step',
    goToStep: 'Go to step {n}',
    step1: {
      n: '01.',
      title: 'Pick your game',
      body: 'Browse our curated selection of verified digital titles.',
    },
    step2: {
      n: '02.',
      title: 'Pay in EUR with your wallet',
      body: 'Secure checkout using your preferred European payment method.',
    },
    step3: {
      n: '03.',
      title: 'Get your key — instantly in your inbox and dashboard',
      body: 'No waiting. Your activation code is delivered the moment payment clears.',
    },
  },
  why: {
    heading: 'Why GladKey',
    body: 'We believe in transparent pricing and a verified supply chain. Every key on our platform is sourced through secure European channels, ensuring you never face hidden fees or region-lock surprises. With 24-hour digital key storage and dedicated European-based support, we\'re here to ensure your purchase is as reliable as the games you play.',
    testimonial:
      '"Straightforward to use, prices are reasonable, and the process was smooth. Exactly what a marketplace should be."',
    testimonialAuthor: 'Martin, Berlin',
  },
  journal: {
    heading: 'From the journal',
    allArticles: 'All articles',
    read: 'Read',
  },
};
